<div>
  <app-display-rubrique-status-on-off
    [title]="
      'P00039.parameters.status.eclairageStandardSCommandeEclairage' | translate
    "
    [value]="
      this.actionStack!.getValue('eclairageStandardSCommandeEclairage') !== 0
    "
  >
  </app-display-rubrique-status-on-off>

  <app-display-rubrique-status-on-off
    [title]="'P00039.status.arret' | translate"
    [value]="
      this.actionStack!.getValue(
        'eclairageStandardSArretEclairageParFonctionVolet'
      ) !== 0
    "
  >
  </app-display-rubrique-status-on-off>

  <app-display-rubrique-status
    [title]="
      'P00039.parameters.status.eclairageStandardSCompteAReboursExtinction24h'
        | translate
    "
    [value]="
      convertSecondsToTime(
        this.actionStack!.getValue(
          'eclairageStandardSCompteAReboursExtinction24h'
        )
      )
    "
  >
  </app-display-rubrique-status>
</div>
